import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import './Scrollable.css'

export const shadowOnTopClass = 'scrollable-top-shadow'

export default class Scrollable extends Component {
  state = { scrolling: false }

  componentDidMount() {
    if (this.props.bottomOnLoad) {
      const el = ReactDOM.findDOMNode(this.ref)
      el.scrollTop = el.scrollHeight
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.scrollToTopKey !== this.props.scrollToTopKey) {
      this.ref.scrollTop = 0
      nextProps.onScrollingChange(false)
    }
  }

  getRef() {
    return this.ref
  }

  render() {
    const {
      children,
      className,
      style,
      innerClassName,
      scrollingClassName,
      notScrollingClassName,
      id,
      onRef = () => {},
    } = this.props
    const { scrolling } = this.state

    const containerClassName = classNames(
      'scrollable scroll-y',
      {
        [scrollingClassName]: scrolling,
        [notScrollingClassName]: !scrolling,
      },
      className
    )

    return (
      <div
        id={id}
        ref={ref => {
          this.ref = ref
          onRef(ref)
        }}
        className={containerClassName}
        onScroll={this.onScroll}
        style={style}
      >
        <div className={innerClassName}>{children}</div>
      </div>
    )
  }

  onScroll = event => {
    const {
      onReachTop,
      topAt,
      onReachBottom,
      bottomAt,
      scrollingStartAt,
      onScrollingChange,
      onScroll,
    } = this.props
    const el = event.target
    const { scrollTop, scrollHeight, offsetHeight } = el

    // Notifies via prop when scroll started or stopped
    const scrolling = scrollTop > scrollingStartAt
    if (scrolling !== this.state.scrolling) {
      this.setState({ scrolling })
      onScrollingChange(scrolling)
    }

    if (scrollTop <= topAt) {
      onReachTop()
    }

    if (scrollHeight - offsetHeight - scrollTop <= bottomAt) {
      onReachBottom()
    }

    onScroll(event)
  }
}

Scrollable.propTypes = {
  scrollingClassName: PropTypes.string,
  notScrollingClassName: PropTypes.string,
  innerClassName: PropTypes.string,
  onReachTop: PropTypes.func.isRequired,
  onReachBottom: PropTypes.func.isRequired,
  onScroll: PropTypes.func.isRequired,
  scrollingStartAt: PropTypes.number.isRequired,
  topAt: PropTypes.number.isRequired,
  bottomAt: PropTypes.number.isRequired,
  scrollToTopKey: PropTypes.string,
  bottomOnLoad: PropTypes.bool.isRequired,
}

Scrollable.defaultProps = {
  scrollingClassName: '',
  notScrollingClassName: '',
  innerClassName: '',
  scrollingStartAt: 0,
  bottomOnLoad: false,
  onReachTop: () => {},
  topAt: 0,
  onReachBottom: () => {},
  onScrollingChange: scrolling => {},
  onScroll: event => {},
  bottomAt: 0,
  scrollToTopKey: null,
}
